// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__q02ww","spinner":"Spinner_spinner__6Ig9D","spin":"Spinner_spin__GJtSS","animate-spin":"Spinner_animate-spin__v8SeA"};